import { render, staticRenderFns } from "./CreatorVideoIndex.vue?vue&type=template&id=2cc642d1&scoped=true&"
import script from "./CreatorVideoIndex.vue?vue&type=script&lang=js&"
export * from "./CreatorVideoIndex.vue?vue&type=script&lang=js&"
import style0 from "./CreatorVideoIndex.vue?vue&type=style&index=0&id=2cc642d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc642d1",
  null
  
)

export default component.exports